export const normalizeOrigin = (origin) => {
  try {
    const url = new URL(origin);
    if (url.hostname === 'localhost') url.hostname = '127.0.0.1';
    return url.origin;
  } catch {
    return origin;
  }
};

export const computeApiBase = () => {
  const envBase = process.env.REACT_APP_API_BASE;
  if (envBase) return envBase.replace(/\/$/, '');
  try {
    const current = new URL(window.location.origin);
    if (current.port) {
      return normalizeOrigin(window.location.origin).replace(/:\d+$/, ':18100');
    }
    return `${normalizeOrigin(window.location.origin)}/api`;
  } catch {
    return 'http://127.0.0.1:18100';
  }
};
